import {
  type CreatCustomerDTO,
  type OrderAddressDTO,
  type SveaOrder,
  type WithOptional
} from 'ecosystem'

export const generateSveaAddresses = (
  sveaOrder: SveaOrder
): {
  billingAddress: OrderAddressDTO
  shippingAddress: OrderAddressDTO
  customerInfo: WithOptional<CreatCustomerDTO, 'type'> & { fullName: string; phone: string }
} => {
  const {
    BillingAddress: billingAddress,
    ShippingAddress: shippingAddress,
    PhoneNumber: mobilePhone,
    EmailAddress: email
  } = sveaOrder

  const {
    FirstName: firstName = '',
    LastName: lastName = '',
    FullName: fullName = ''
  } = billingAddress ?? {}

  return {
    billingAddress: {
      address1: billingAddress?.StreetAddress ?? '',
      address2: '',
      country: billingAddress?.CountryCode ?? '',
      mobilePhone,
      postalCode: billingAddress?.PostalCode ?? '',
      postalRegion: billingAddress?.City ?? '',
      attention: fullName,
      reference: ''
    },
    shippingAddress: {
      address1: shippingAddress?.StreetAddress ?? '',
      address2: '',
      country: shippingAddress?.CountryCode ?? '',
      mobilePhone,
      postalCode: shippingAddress?.PostalCode ?? '',
      postalRegion: shippingAddress?.City ?? '',
      attention: shippingAddress?.FullName ?? '',
      reference: ''
    },
    customerInfo: {
      email,
      firstName,
      lastName,
      phone: mobilePhone,
      fullName
    }
  }
}
